import "../../../../styles/uniqueNews.css";
import React from "react";
import api from "../../../../services/api";
import CarouselIMG from "../../img/CarouselIMG";
import Loading from "../../others/Loading";
import { imagemURL, link_mapa } from "../../../../services/variables";
import styles from "../../../../styles/module/news3.module.css";

export default class Seletivo14 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsLast: [],
      dataFormat: "",
      renderLoading: true,
      multiImg: [],
    };
  }

  componentDidMount() {
    api
      .post(`/news/unique/${this.props.slugNewsSystem}`)
      .then((res) => {
        const result = res.data;
        if (result.err) {
          //this.setState({renderLoading: false});
          //this.setState({renderLoading: false});
        } else {
          console.log(result);
          this.setState({ newsLast: result.res, renderLoading: false });
        }
      })
      .catch((err) => console.log("erro, DB"));
  }

  render() {
    return (
      <>
        {this.state.renderLoading ? (
          <Loading />
        ) : (
          <div className={styles.container}>
            {this.state.newsLast.map((news, i) => (
              <div className={styles.newsItem} key={i}>
                <div className={`${styles.header} ${styles.ajuste}`}>
                  <h1 className={styles.title}>
                    Seletivo para Gestores Escolares da Rede Pública Municipal
                    de Ensino de Codó - MA
                  </h1>
                </div>
                <div className={styles.imageWrapper}>
                  {news.IMG === "logo.jpg" || "logo.png" ? null : (
                    <img
                      width={360}
                      alt="imagem da notícia"
                      src={imagemURL + news.IMG}
                    />
                  )}
                </div>

                <div className="section-unique-news">
                  <div className="cards-unique-news" key={i}>
                    {news.IMG === "logo.jpg" || "logo.png" ? null : (
                      <div>
                        <img
                          alt="imagem da notícia"
                          src={imagemURL + news.IMG}
                          className="card-unique-img"
                        />
                      </div>
                    )}
                    <div className="card-unique-txt">
                      <div className="title-unique-body"></div>
                      <div className="news-unique-body">
                        <p>
                          A PREFEITURA MUNICIPAL DE CODÓ (MA), situada na Praça
                          Ferreira Bayma, nº 538. Centro. Codó (MA), por meio da
                          Secretaria Municipal de Educação, Ciência, Tecnologia
                          e Inovação - SEMECTI e Secretaria Municipal de
                          Administração - SEAD, estabelece normas específicas e
                          torna público para conhecimento dos interessados o
                          Processo Seletivo Interno para Gestores Escolares da
                          Rede Pública Municipal de Ensino de Codó - MA.
                        </p>

                        <p>
                          <strong>Anexos:</strong> <br />
                          <ul>
                            <li>
                              <span>Link de inscrição:</span> &nbsp;
                              <a
                                href="https://semecti.codo.ma.gov.br/seletivos/index.php?class=LoginForm"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>
                            <li>
                              <span>Edital 07/2025:</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_5345d931-1a68-43bf-9210-4560fc238a40.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Retificação Nº 1 do Edital 07/2025:</span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads?n=06104863000195&a=CP_20250605_RETIFICA%C3%87%C3%83O%2001%20EDITAL%2007-2025-GAB-SEMECTI.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Retificação Nº 2 do Edital 07/2025:</span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_70edf63a-6488-42e0-b49b-5088acc455ee.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>
                                Resultado Preliminar 1ª FASE do Edital 07/2025:
                              </span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_2abb4571-b57c-4bd9-b7af-bb5628a2ddf3.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>
                                Resultado Final 1ª FASE do Edital 07/2025:
                              </span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_499d907d-3136-4e42-a9b8-55fcfef37b1e.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>
                                Gabarito Preliminar das provas 2ª fase:
                              </span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_c11ab9cf-4cb1-4cbb-a4c7-22afd21d33a4.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>
                                Resultado Preliminar da Prova 2ª Fase:
                              </span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_de349217-d377-40b5-a23b-9e02d584bbad.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Resultado Final da Prova 2ª Fase:</span>{" "}
                              &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_f042ea42-4921-4593-bb50-f154ecfe3796.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Ato Administrativo 01:</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_43997d34-9107-4e7c-824d-a8920d9cff66.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Resultado Preliminar - 3ª Fase Consulta Pública:</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_fba71bee-e32e-4303-af72-28d6ff9a1485.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>

                            <li>
                              <span>Resultado Preliminar - 3ª Fase Consulta Pública -  UIM ANANIAS MURAD:</span> &nbsp;
                              <a
                                href="https://administracaopublica.com.br/downloads/other?n=06104863000195&p=anexo&a=anexo_925ff92b-b7ca-4f02-a819-a174bd63fff4.pdf"
                                style={{ color: "blue" }}
                                target="blank"
                              >
                                Clique aqui!
                              </a>
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                  <CarouselIMG img={news.MULTIPLE_IMG} />
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  }
}
